import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <Section emoji="🔄" eyebrow="The shift" title={<>
          From guessing in consultation… to{' '}
          <span className="text-teal-600" data-id="element-30" data-mp="3sj7hdr1rjfe0">confident clinical decisions</span>
        </>} subtitle="Over 2,400+ hours of study condensed into a step-by-step clinical pathway you can follow immediately." className="bg-cream" data-id="element-29" data-mp="3oezrhqjkjte7">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-31" data-mp="34sjyybu817d7">
        <div className="rounded-3xl border border-rose-200/70 bg-rose-50/60 p-4 sm:p-5" data-id="element-32" data-mp="39qv6gfx1n5s9">
          <h3 className="flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-[0.14em] text-rose-700" data-id="element-33" data-mp="39oiq276xp3hb">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-rose-600 text-white" data-id="element-34" data-mp="30pxamkwre4kr">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-35" data-mp="x40ue80eii4e" />
            </span>
            Before
          </h3>
          <ul className="mt-4 space-y-3" data-id="element-36" data-mp="t1x7mn8a7r3t">
            {beforeItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-37" data-mp="172zv94exd9gu">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose-500" aria-hidden="true" data-id="element-38" data-mp="170ndar962z3s" />
                <span className="text-[14px] leading-snug text-navy/75 sm:text-[15px]" data-id="element-39" data-mp="edau8r27t9f8">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border border-teal-200 bg-teal-50/70 p-4 sm:p-5" data-id="element-40" data-mp="o45g3ubju705">
          <h3 className="flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-[0.14em] text-teal-700" data-id="element-41" data-mp="jdf7m87tto18">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-teal-600 text-white" data-id="element-42" data-mp="3rrxbryuncjfk">
              <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-43" data-mp="3mt2vb3k5j6ym" />
            </span>
            With the Pathway
          </h3>
          <ul className="mt-4 space-y-3" data-id="element-44" data-mp="1qon37wyw7z1p">
            {afterItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-45" data-mp="1vo9brt3s0r46">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-600" aria-hidden="true" data-id="element-46" data-mp="20g0y1rfwgaoi" />
                <span className="text-[14px] font-medium leading-snug text-navy sm:text-[15px]" data-id="element-47" data-mp="24hcmvuqy8rvn">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-md" data-id="element-48" data-mp="1cst1pz0g8bym">
        <CTAButton label="I want the clear protocol" sublabel="One-time payment · Lifetime access" data-id="element-49" data-mp="1gricdju3rfek" />
      </div>
    </Section>;
}